"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var utils_1 = require("../utils");
var config_1 = require("../config");
var useRequest = function (apiName) {
    var ntConfigFromProvider = (0, config_1.useNTConfig)();
    var baseURL = (0, utils_1.determineBaseApiUrl)(apiName, ntConfig !== null && ntConfig !== void 0 ? ntConfig : ntConfigFromProvider);
    var request = (0, react_1.useCallback)(function (_a) {
        var url = _a.url, _b = _a.method, method = _b === void 0 ? 'GET' : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, params = _a.params, data = _a.data, cancelToken = _a.cancelToken;
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var res;
            return (0, tslib_1.__generator)(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, (0, axios_1.default)({
                            baseURL: baseURL,
                            method: method,
                            params: params,
                            data: data,
                            url: url,
                            headers: headers,
                            cancelToken: cancelToken,
                        })];
                    case 1:
                        res = (_d.sent());
                        return [2 /*return*/, res];
                }
            });
        });
    }, [baseURL]);
    return { request: request };
};
exports.default = useRequest;
